if (!customElements.get('share-button')) {
  const ShareButtonBase = window.DetailsDisclosure || HTMLElement;
  customElements.define('share-button', class ShareButton extends ShareButtonBase {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('.map_url, .field__input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      this.mainDetailsToggle = this.mainDetailsToggle || this.querySelector('details');

      if (navigator.share && this.mainDetailsToggle) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else if (this.mainDetailsToggle) {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      } else {
        const copyButton = this.querySelector('.share-button__copy');
        if (copyButton) copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    showCopySuccess() {
      this.elements.successMessage.classList.remove('hidden');
      this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      this.elements.closeButton.classList.remove('hidden');
      this.elements.closeButton.focus();
    }

    fallbackCopyText(textToCopy) {
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      tempInput.setAttribute('readonly', '');
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);
      tempInput.select();
      const isCopied = document.execCommand('copy');
      document.body.removeChild(tempInput);
      return isCopied;
    }

    copyToClipboard(event) {
      if (event) event.preventDefault();
      const textToCopy = this.elements.urlInput ? this.elements.urlInput.value : this.urlToShare;
      if (!textToCopy) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy).then(() => {
          this.showCopySuccess();
        }).catch(() => {
          if (this.fallbackCopyText(textToCopy)) this.showCopySuccess();
        });
        return;
      }

      if (this.fallbackCopyText(textToCopy)) this.showCopySuccess();
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
